import { useEffect, useState } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import watchTriggers from '../../features/quote/data/WatchTriggers';
import { actions, getCurrentStep, getQuote } from '../../features/quote/QuoteSlice';
import { Field, WatchTriggerActionInterface, WatchTriggerInterface } from '../../types';
import { WatchTriggerActionType } from '../../types/enum';
import useActions from './useActions';

const useWatchTriggers = (): any => {
  const [loadedTriggers, addToTriggers] = useState(watchTriggers);
  const quoteData = useSelector(getQuote);
  const currentStep = useSelector(getCurrentStep);
  const { runAction } = useActions(loadedTriggers);
  const dispatch = useDispatch();

  type stringDateBool = (string | Date | boolean);

  const compareShutOffDate = (valueArray: (stringDateBool)[], value: stringDateBool): boolean => {
    const result = valueArray.find((val: stringDateBool) => {
      const date = (typeof value === 'string') ? new Date(value) : value;
      return date > val;
    });
    return !!result;
  };
  const checkForTriggers = (field: Field, value: string | boolean | Date, index = 0) => {
    if (Object.prototype.hasOwnProperty.call(loadedTriggers, field.formId)) {
      const fieldId = field.formId;
      loadedTriggers[fieldId].forEach(async (trigger: WatchTriggerInterface) => {
        if (trigger.values) {
          if (trigger.trigger) {
            // Check if other field matches trigger value
            const triggerField = currentStep.fields.find(
              (foundField: any) => foundField.formId === trigger.trigger?.target,
            );
            if (triggerField && typeof trigger.trigger.target === 'string') {
              if (!trigger.trigger?.values?.includes(
                triggerField.value,
              )) {
                return;
              }
            }
          }
          const triggerIsInception = field.formId === 'more_inception';
          const test = triggerIsInception && compareShutOffDate(trigger.values, value);
          if (trigger.values.includes(value) || trigger.values.includes('all') || test) {
            runAction(field.formId, trigger.on, value, index + trigger.index);
          } else {
            runAction(field.formId, trigger.off, value, index + trigger.index);
          }
        } else if (trigger.operator) {
          runAction(
            field.formId,
            (trigger.operator(value as string, currentStep.fields)
              ? trigger.on : trigger.off),
            value,
            trigger.index + index,
          );
        }
      });
    }
  };

  useEffect(() => {
    dispatch(actions.setIsLoading(true));
    setTimeout(() => {
      if (currentStep && currentStep.fields) {
        currentStep.fields.forEach((field: Field, index: number) => {
          if (field.value && field.value !== null) {
            checkForTriggers(field, field.value, index);
          }
        });
      }
      dispatch(actions.setIsLoading(false));
    }, 500);
  }, [quoteData.step.innerStep, quoteData.step.step]);

  useEffect(() => {
    dispatch(actions.setIsLoading(true));
    if (quoteData.formQueue && quoteData.formQueue.length) {
      quoteData.formQueue.forEach((queue: any) => {
        queue.fields.forEach((field: Field, index: number) => {
          const value = quoteData.data[field.formId] === 'on'
          || quoteData.data[field.formId]
          || (field.attributes && field.attributes.checked === 'checked')
          || field.value;
          if (value && value !== null) {
            checkForTriggers(field, value, queue.index + index);
          }
        });
      });
    }
    dispatch(actions.setIsLoading(false));
  }, [quoteData.formQueue]);

  useEffect(() => {
    if (quoteData.numberOfEmployees < 2 && window.quickInfoData) {
      // Will always be one as first array item is a placeholder 'Please select'
      const firstOption = 1;
      // We have to set number of fee earners to 1 and trigger the process
      checkForTriggers(
        quoteData.showData[window.quickInfoData.numberOfFeeEarnersCtrl].field,
        quoteData.showData[window.quickInfoData.numberOfFeeEarnersCtrl]
          .field.options[firstOption].value,
      );
    }
  }, [quoteData.numberOfEmployees]);

  return [
    loadedTriggers,
    addToTriggers,
    checkForTriggers,
  ];
};

export default useWatchTriggers;
